<template>
  <v-autocomplete
    v-model="VALOR_COMPUTED"
    label="Selecione uma Lista"
    outlined
    hide-details
    v-bind="$attrs"
    :items="itens"
  />
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  }
}
</script>

<script setup>
import {computed, onMounted, ref} from "vue";
import api from "@/api/api";
import {logout} from "@/helpers";

const props = defineProps({
  modelValue: [String, Number],
  filiais_destino: Array,
});

const emit = defineEmits(['update:modelValue']);

const VALOR_COMPUTED = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', Number(valor)),
});

onMounted(buscarItens);

const itens = ref([]);

function buscarItens() {
  const params = {
    filiais_destino: props.filiais_destino,
  };

  api.get('drp/listas-separacao', { params })
    .then(resposta => {
      itens.value = resposta.data.listas
        .map(item => ({value: item.id, text: `${item.id} - ${item.nome}`}));
    })
    .catch(logout);
}
</script>
